module.exports = __webpack_public_path__ + "img/D3CAAB_8C866E_C0B89A_AEA68A-256px.6cbbe32b.png";